import { z } from "zod";

export const lockBlockSchema = z.object({});
